/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetSubtitleLinkPartialUpdate
 */
export interface AssetSubtitleLinkPartialUpdate {
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof AssetSubtitleLinkPartialUpdate
     */
    subtitle?: AssetMiniReference;
    /**
     * 
     * @type {string}
     * @memberof AssetSubtitleLinkPartialUpdate
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubtitleLinkPartialUpdate
     */
    key?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetSubtitleLinkPartialUpdate
     */
    asset?: number;
}

export function AssetSubtitleLinkPartialUpdateFromJSON(json: any): AssetSubtitleLinkPartialUpdate {
    return AssetSubtitleLinkPartialUpdateFromJSONTyped(json, false);
}

export function AssetSubtitleLinkPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSubtitleLinkPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtitle': !exists(json, 'subtitle') ? undefined : AssetMiniReferenceFromJSON(json['subtitle']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
    };
}

export function AssetSubtitleLinkPartialUpdateToJSON(value?: AssetSubtitleLinkPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtitle': AssetMiniReferenceToJSON(value.subtitle),
        'label': value.label,
        'key': value.key,
        'asset': value.asset,
    };
}


